export default /*@ngInject*/ function ($http, errorsDataService) {
    var factory = {
        exportExcludedUsers,
        importExcludedUsers,
        updateExcludedUser
    };

    return factory;

    async function exportExcludedUsers() {
        try {
            return await $http.get(`${apiUrl}/api/universal/usermaster/exclude/export`, { responseType: "blob" });
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function importExcludedUsers(fd) {
        try {
            return await $http.put(`${apiUrl}/api/universal/usermaster/exclude/import`, fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function updateExcludedUser(data) {
        try {
            return await $http.put(`${apiUrl}api/universal/usermaster/exclude`, data);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    function sendError(err) {
        throw err;
    }

    function showError(err) {
        errorsDataService.catch(err);
    }

}